<template>
    <div>
      <a
        v-if="model.chat"
        class="action"
        href="#"
        target="_blank"
        @click.prevent="openChat"
      >
        <div class="icon"></div>
        <div class="description">
          <span>
            {{ $t('webstars.buttons.chat.title') }}
          </span>
          <small>
            {{ $t('webstars.buttons.chat.subtitle') }}
          </small>
        </div>
      </a>
      <router-link
        v-else-if="subscription_plan"
        class="action"
        :to="{ name: 'subscribe', query: { plan: subscription_plan.id } }"
      >
        <div class="icon"></div>
        <div class="description">
          <span>
          {{ $t('webstars.buttons.chat.not_available') }}
          </span>
          <small>
            {{ $t('webstars.buttons.chat.subtitle') }}
          </small>
        </div>
      </router-link>
<!--      <div-->
<!--        v-else-->
<!--        class="action"-->
<!--      >-->
<!--        ERROR NO PM-->
<!--      </div>-->
    </div>
</template>
<script>

export default {
    components: {},
    props: {
      subscription_plan: {
          type: Object,
          required: false
        },
      model: {
          type: Object,
          required: true
        },
    },
    data(){
        return {
        };
    },
    methods: {
      openChat() {
        this.model.chat && window.open(this.model.chat, '_blank')
      }
    },
  mounted(){
      // console.log(this.subscription_plan.premium)
      // console.log(this.model.chat !== false)
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.action{
  display: flex;
  width: 300px;
  height: 50px;
  border-radius: 15px;
  text-align: center;
  background: #cccccc;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  font-weight: bold;
  
  .icon {
    width: 80px;
    height: 50px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("/img/btn/btn-chat.png");
  }
  
  .description {
    width: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    
    small{
      font-size: .6em;
    }
  }
}
</style>